module.exports = __webpack_public_path__ + "img/banner_1_km.2663151a.png";